import React, { useEffect } from 'react';

import useTextContents from '../../hooks/useTextContents'
import PageScreen from '../../components/organisms/Page/PageScreen'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'


import { ReactComponent as ErrorIcon } from '../../icons/svg/error-page-icon.svg';
import "./UserOfflinePageStyles.scss";



const UserOfflinePage = () => {
    return (
        <PageScreen
            title={{ title: 'Brak internetu', line: true }}
            icon={{ icon: ErrorIcon, decorative: true, color: 'var(--color-primary-600)' }}
        >
            <div className='user-offline-page-description'>
                <Paragraph>
                    Nie martw się. Po odzyskaniu połączenia wrócisz do procesu dokładnie tam, gdzie przerwałeś.
                </Paragraph>
                <Paragraph bold>
                    Dodatkowo wysłaliśmy Tobie SMS-a oraz e-mail z linkiem, który pozwoli Ci wrócić do wniosku w dowolnym momencie.
                </Paragraph>
            </div>
        </PageScreen>
    )
}
  
export default UserOfflinePage